<template>
  <div class="system-configure">
    <main>
      <a-row style="padding:0 20px;">
        <a-form-model :model="sysSetForm" ref="sysSetForm"  style="margin-top: 15px">
            <a-col :span="24">
              <a-form-model-item label="录屏清理">
                <a-radio-group v-model="sysSetForm.screenCleanEnable" @change="onChange">
                  <a-radio :style="radioStyle" :value="true">
                      不清理
                  </a-radio>
                  <a-radio :style="radioStyle" :value="false">
                   自动清理<a-input-number v-model="sysSetForm.screenCleanDay" @change="numberInput" :disabled="sysSetForm.screenCleanEnable" style="margin: 0 10px" :min="1" :max="30" />天以前的录屏文件
                    <a-button type="link" @click="screencapClear">
                      立即清理
                    </a-button>
                  </a-radio>

                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" class="sysSet-operate">
              <a-form-model-item >
                <a-button type="primary"  @click="fileSubmit" :loading="submitLoad" style="color: #ffffff">
                  保存
                </a-button>
              </a-form-model-item>
            </a-col>
        </a-form-model>
      </a-row>
    </main>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      btnLoad: false,
      submitLoad: false,
      loading: false,
      imageUrl:  '',
      sysSetForm:{
        logoImg:"",
        screenCleanEnable:true,
        screenCleanDay:1

      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      // 文件上传
      completeFileList: [],
    };
  },
  methods: {
    // 监听数字输入框
    numberInput(val){
      if (val == null){
        this.sysSetForm.screenCleanDay = 1
      }
    },
    // 录屏清理
    screencapClear(){
      this.axios
          .post("/setting/cleanScreenRec", )
          .then((res) => {
            // console.log(res.data);
            if (res.code === 200) {
              notification.success({
                message: '清理录屏成功',
                duration: 3,
                customClass: "batch-import",
              })
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 录屏清理
    onChange(e){
      if (e.target.value){
        this.sysSetForm.screenCleanDay = 0
      }else{
        this.sysSetForm.screenCleanDay = 1

      }
    },

    // 保存
    fileSubmit(){
      this.$refs.sysSetForm.validate((valid) => {
        if (valid) {
          this.submitLoad = true;
          this.axios
              .post('setting/updateScreenSetting',  {screenRecClr:this.sysSetForm.screenCleanDay})
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

  },
  beforeMount(){

    this.axios
        .post("/setting/getScreenSetting", )
        .then((res) => {
          if (res.code === 200) {
            if (res.data.screenRecClr){
              this.sysSetForm.screenCleanEnable = false
              this.sysSetForm.screenCleanDay = res.data.screenRecClr
            }else{
              this.sysSetForm.screenCleanEnable = true
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    // 判断录屏清理
    this.onChange({
      target:{
        value:true
      }
    })
  },
};
</script>

<style lang="scss" scoped>
.system-configure {
  header {
    display: flex;
    align-items: flex-end;
    margin: -7px -8px 0;
    padding: 16px;
    letter-spacing: 1px;
    background-color: #fff;

    h3 {
      margin-bottom: 0;
      line-height: 20px;
      padding-left: 12px;
      border-left: 4px solid #3373f2;
      font-size: 18px;
      //font-weight: bold;
    }

    span {
      line-height: 16px;
      margin-left: 10px;
      color: #808080;
    }
  }

  main {
    margin: 16px 0px;
    background-color: #fff;
    //   padding: 0 16px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07),
    0 1px 10px 0 rgba(0, 0, 0, 0.06);
    border-radius: 4px;


    ::v-deep .ant-form-item-label{
      font-weight: 600;
    }
    .ant-form-item label{
      font-weight: 600;
    }
    .logo-item{
      ::v-deep .ant-upload.ant-upload-select-picture-card{
        width: 200px;
        height: 60px;
      }
      ::v-deep .ant-form-item-children{
        width: 100%;
        display: flex;
        align-items: flex-end;
        margin-top: 5px;
        .imgShow{
          width: 184px;
          height: 60px;
          object-fit: cover;
        }
      }
      ::v-deep .ant-upload-picture-card-wrapper{
        width: 13%;
      }
      .tips-textColor{
        color: #d1d1d1;
        height: 35px;
      }
    }

    //按钮
    .sysSet-operate{
      text-align: right;
      margin-top: 392px;
      .ant-btn:nth-child(1){
        margin-right: 15px;
        background-color: #ecf0fe;
        color: #3373f2;
        letter-spacing: 1px;
      }
      .ant-btn:nth-child(2){
        width: 70px;
      }
    }

  }
}
</style>
  